<section *ngIf="!showOutage">
  <app-header></app-header>
  <!-- <app-navbar></app-navbar> -->
  <div class="view-container" id="view">
    <app-breadcrumb></app-breadcrumb>
    <router-outlet></router-outlet>
    <app-footer></app-footer> <!--Kept footer inside to remove unwanted spaces-->
  </div>

  <Section class="dialogSection" *ngIf="opened">
    <kendo-dialog [width]="500"
                  title="{{dialogTitle}}" (close)="logout()">
      <div class="modal-body">
        {{idleState}}
        <br><br>
        <div class="row mrgbtm" *ngIf="!timedOut">
          <div class="col-4 col-md-6">
            <button type="button" (click)="logout()" class="btn btn-danger">Logout</button>
          </div>
          <div class="col-8 col-md-6">
            <button type="button" (click)="continue()" class="btn btn-success">Continue Shopping!</button>
          </div>
        </div>
        <div class="mrgbtm" *ngIf="timedOut" style="float:right;">
          <button type="button" (click)="closeInfoModal()" class="btn btn-success">Ok</button>
        </div>
      </div>
    </kendo-dialog>
  </Section>
</section>
<section *ngIf="showOutage">
  <app-outage [outageObj]="outageObj"></app-outage>
</section>

